type Milestone = {
  title: string
  status: 'done' | 'doing' | 'next'
  items: string[]
}

const milestones: Milestone[] = [
  {
    title: 'Personality Memory: MVP',
    status: 'done',
    items: [
      'Capture what matters from conversations',
      'Private by default, user-controlled sharing',
      'Fast recall for consistent tone and fewer repeats',
      'Safe updates as preferences and goals change',
    ],
  },
  {
    title: 'MVP: 402 → negotiate → execute → receipt',
    status: 'doing',
    items: [
      'Capture a 402 challenge and turn it into a clear payment request',
      'Negotiate terms within user-defined limits',
      'Execute step-by-step with caps and deadlines',
      'Receipt: what happened, fees, timing, and final delivery',
    ],
  },
  {
    title: 'Observable execution and rollback paths',
    status: 'next',
    items: ['Live status and balance checks', 'Safe retries', 'Timeouts and refunds', 'Clear cost reporting'],
  },
  {
    title: 'Liquidity pools and LP incentives',
    status: 'next',
    items: ['Multi-chain liquidity vaults', 'Risk limits for supplementation', 'LP rewards and accounting'],
  },
  {
    title: 'Scale: ecosystem and integrations',
    status: 'next',
    items: ['More chains and assets', 'More x402 providers', 'A complete external API and SDK'],
  },
]

export default function Roadmap() {
  return (
    <section id="roadmap" className="bg-bg">
      <div className="container-x py-14 md:py-18">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <h2 className="text-2xl font-semibold tracking-tight md:text-3xl">Roadmap</h2>
            <p className="mt-2 max-w-3xl text-white/65">
              We publish our roadmap so partners and future users can see the deliverables, quality bars, and boundaries at each step.
            </p>
          </div>
          <div className="text-xs text-white/50">
            Status: <span className="text-primary">In progress</span> / Next / Done
          </div>
        </div>

        <div className="mt-8 grid gap-5 md:grid-cols-2">
          {milestones.map((m) => (
            <MilestoneCard key={m.title} milestone={m} />
          ))}
        </div>
      </div>
    </section>
  )
}

function MilestoneCard(props: { milestone: Milestone }) {
  const { milestone } = props
  const tag =
    milestone.status === 'done'
      ? { label: 'Done', cls: 'bg-primary text-black' }
      : milestone.status === 'doing'
        ? { label: 'In progress', cls: 'bg-white/10 text-white' }
        : { label: 'Next', cls: 'bg-secondary/20 text-white' }

  return (
    <div className="glass p-7">
      <div className="flex items-start justify-between gap-4">
        <div className="text-base font-semibold text-white/90">{milestone.title}</div>
        <span className={`rounded-full px-3 py-1 text-xs font-semibold ${tag.cls}`}>{tag.label}</span>
      </div>
      <ul className="mt-4 list-disc space-y-2 pl-5 text-sm text-white/65">
        {milestone.items.map((i) => (
          <li key={i}>{i}</li>
        ))}
      </ul>
    </div>
  )
}
